import React from 'react';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';
import { Image } from '$partials/media';
import { Tag } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').LetPropertiesCarousel}
 */
const LetPropertiesCarousel = ({
    title,
    listing,
    letItems: items
}) => {
    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 2,
            breakpoints: {
                640: {
                    slidesPerView: 'auto'
                },
                1024: {
                    slidesPerView: 'auto'
                }
            },
        }}>
            <div className='overflow-hidden container featured-articles-carousel-container overhang-left sm-overhang-left-0 md-overhang-left-0'>
                <div className='col-12 flex items-center justify-between px5 md-px6 py5 md-py7 border-bottom grey bg-sand'>
                    <h2 className='type-style-2 black'>{title}</h2>

                    <div className='flex flex-row items-center'>
                        {listing &&
                                <a
                                    className='type-style-5 md-mr6 black link'
                                    href={listing.url}>
                                    View All
                                </a>
                        }

                        <div className='hide md-show'>
                            <CarouselNavigation look='row'/>
                        </div>
                    </div>
                </div>

                <CarouselWrapper className='swiper-wrapper'>
                    {items?.map((item, i) => {
                        if (!item) { return null; }

                        const image = item.listingMedia?.[0]?.image;

                        return (
                            <CarouselSlide
                                className='flex carousel-slide'
                                index={i}
                                key={`featured-property-carousel-${item.id}-${i}`}>
                                <a
                                    className='link-reset flex'
                                    href={item.url}>
                                    <div className='absolute top-0 ml5 md-ml6 mt5 md-mt6 z2'>
                                        <Tag
                                            bgColor='yellow'
                                            title={item.publicSellingStatus} />
                                    </div>
                                    <div
                                        className='flex flex-col bg-sand px5 md-px6 pt5 pb6 md-pt6 md-pb9 border-top grey carousel-item-fixed-height'>
                                        <div
                                            style={{
                                                width: `${(image?.width / image?.height)}em`
                                            }}>
                                            {image &&
                                                <div className='carousel-item-height'>
                                                    <Image {...image} />
                                                </div>
                                            }
                                            <div className='mt5 sm-mt7 black'>
                                                <h3 className='type-style-3'>
                                                    {item.heading}
                                                </h3>
                                                <div className='mt3'>
                                                    <p className='type-style-5'>{item.propertyName}</p>
                                                    <p className='type-style-5'>{item.area} {item.outwardCode}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>
            </div>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default LetPropertiesCarousel;
